<template>
    <div class="form">
        <form>
            <validation-input
                v-for="input in formInputs"
                :key="input.key"
                :vid="input.key"
                v-model="form[input.key]"
                :rules="input.rules"
                :placeholder="input.placeholder"
                :type="input.type"
                :label="input.label"
                :name="input.name"
            />
        </form>
        <vue-recaptcha
            v-if="showCaptcha"
            class="mb-3"
            ref="captcha"
            @verify="changeCaptcha"
            @expired="changeCaptcha(false)"
            :sitekey="captchaSiteKey"
            loadRecaptchaScript
        />
    </div>
</template>
<script>
import VueRecaptcha from "vue-recaptcha";
import ValidationInput from "../Forms/ValidationInput.vue";
import { initialForm, inputs } from "./helpers";

export default {
    components: { ValidationInput, VueRecaptcha },
    name: "AuthLogin",
    model: {
        prop: "form",
        event: "change",
    },
    props: {
        form: {
            type: Object,
            default: () => Object.assign({}, initialForm),
        },
        showCaptcha: {
            type: Boolean,
        },
        captchaSiteKey: {
            type: String,
        }
    },
    data() {
        return {
            formInputs: inputs,
        };
    },
    methods: {
        changeCaptcha(token) {
            this.$emit("change-captcha", token);
        },
        resetCaptcha() {
            this.$refs["captcha"] && this.$refs["captcha"].reset();
        },
    },
};
</script>
